interface TreenumberData {
    id: string,
    name: string,
    symbolSize: number,
    itemStyle: {
        color?: string,
        opacity?: number,
    },
    treenumber?: string,
    count: number
}

interface FixedData {
    name: string,
    treenumber: string,
    flag?: boolean
}

interface SortItem {
    count: number,
    id: string,
    itemStyle: {
        color?: string,
        opacity?: number
    },
    name: string,
    symbolSize: string,
    treenumber: string
}

interface ArrayItem {
    count: number,
    id: string,
    itemStyle: {
        color?: string,
        opacity?: number
    },
    name: string,
    symbolSize: number,
    treenumber?: string
}

interface LinkItem {
    id?: string,
    source?: string,
    target?: string
}

interface ParentNodeItem {
    count: number,
    id: string,
    itemStyle: {
        color?: string,
        opacity?: number
    },
    name: string,
    symbolSize: number,
    treenumber?: any
}

// 给数据按比例计算节点大小
function calculateSize(item: TreenumberData, maxValue: number) {
    if (item.count === maxValue) {
        item.symbolSize = 50
    } else if (item.count > 0.8 * maxValue) {
        item.symbolSize = 40
    } else if (item.count > 0.5 * maxValue) {
        item.symbolSize = 30
    } else if (item.count > 0.2 * maxValue) {
        item.symbolSize = 20
    } else {
        item.symbolSize = 10
    }
    return item
}

// 处理传过来的数据的排序函数
export function processing(keyword: string, array: any) {
    let fixedData = [
        { name: 'Anatomy', treenumber: 'A' },
        { name: 'Organisms', treenumber: 'B' },
        { name: 'Diseases', treenumber: 'C' },
        { name: 'Chemicals and Drugs', treenumber: 'D' },
        { name: 'Analytical, Diagnostic and Therapeutic Techniques, and Equipment', treenumber: 'E' },
        { name: 'Psychiatry and Psychology', treenumber: 'F' },
        { name: 'Phenomena and Processes', treenumber: 'G' },
        { name: 'Disciplines and Occupations', treenumber: 'H' },
        { name: 'Anthropology, Education, Sociology, and Social Phenomena', treenumber: 'I' },
        { name: 'Technology, Industry, and Agriculture', treenumber: 'J' },
        { name: 'Humanities', treenumber: 'K' },
        { name: 'Information Science', treenumber: 'L' },
        { name: 'Named Groups', treenumber: 'M' },
        { name: 'Health Care', treenumber: 'N' },
        { name: 'Publication Characteristics', treenumber: 'V' },
        { name: 'Geographicals', treenumber: 'Z' }
    ]
    let flag = true
    fixedData.forEach((item: FixedData, index: number) => {
        flag = true
        array.forEach((ite: ArrayItem, ind: number) => {
            if (item.treenumber === ite.treenumber?.slice(0, 1)) {
                flag = false
            }
        })
        if (flag) {
            item.flag = true
        }
    })
    fixedData = fixedData.filter((item: FixedData) => !item.flag)
    // 拼接固定的16位的数组
    array = fixedData.concat(array)
    // 根据 treenumber 的首字母及长度进行排序
    array.sort((a: SortItem, b: SortItem) => {
        return a.treenumber[0].charCodeAt(0) - b.treenumber[0].charCodeAt(0) || a.treenumber.length - b.treenumber.length
    })
    // 生成一个关键字的对象把他放在数组的首位,要在 treenumber 之后 unshift 进数组第一位
    let temp = { name: keyword, symbolSize: 60 }
    array.unshift(temp)
    // 添加id
    array.forEach((item: SortItem, index: number) => {
        item.id = index.toString()
        item.itemStyle = {}
    })
    array[0].itemStyle = { color: '#2F7BF3' }
    // 去掉没有count的对象
    let screenArray = array.filter((item: ArrayItem) => item.count)
    // 获取数据中最大的count
    const maxValue = Math.max.apply(Math, screenArray.map(function (o: ArrayItem) { return o.count }))
    array.forEach((item: ArrayItem) => {
        if (item.id === '0') {
            item.symbolSize = 60
        } else if (item.treenumber !== undefined && item.treenumber.length === 1) {
            item.symbolSize = 5
        } else {
            // 除去固定的，给剩余节点赋值大小
            item = calculateSize(item, maxValue)
        }
    })
    // 清空数组中的 empty
    array = array.filter((item: ArrayItem) => item)
    return array
}

// 判断是否是节点的 source 的函数
function isParentNode(kgnode: ParentNodeItem, data: ArrayItem[]) {
    // 因为之前以及按长度和字母排序了，所以选择倒着判断是否是父节点
    for (let i = data.length - 1; i > 0; i--) {
        if (kgnode.treenumber !== data[i - 1].treenumber && kgnode.treenumber.indexOf(data[i - 1].treenumber) === 0) {
            return {
                source: data[i - 1].id,
                target: kgnode.id
            }
        }
    }
}
// 然后生成 link 数组
export function relationNode(data: TreenumberData[]) {
    const link: LinkItem[] = []   // 存放节点关系
    data.forEach((item: TreenumberData) => {
        let temp: LinkItem = {}
        temp.id = item.id
        if (item.treenumber !== undefined && item.treenumber.length === 1) {
            temp.source = '0'
            temp.target = item.id
        } else if (item.treenumber !== undefined) {
            const obj = isParentNode(item, data)   // 返回节点的父节点
            if (obj !== undefined) {
                temp.source = obj.source
                temp.target = obj.target
            }
        }
        link.push(temp)
    })
    // 去掉关键字留下关系数组
    link.shift()
    return link
}


